import React from 'react';
import './Link.css'
import { Link as RouterLink } from 'react-router-dom';

function Link(props) {

    if (props.to) {
        return (
            <RouterLink 
                to={props.to}
                onClick={props.onClick}
                className={props.color + " " + props.hover}
            >
                {props.children}
            </RouterLink>
        );
    }
    
    return (
        <a href={props.link}
        target="_blank" 
        onClick={props.onClick}
        className={props.color + " " + props.hover}>{props.children}</a>
    )
}

export default Link;